import { useMemo } from 'react';
import { findPaymentPeriodWithKey } from 'types';

function getBloom({ goal, loanMonths }) {
  let bloom = 0;
  const MINIMUM_AMOUNT_BLOOM = 100000000;
  if ((loanMonths >= 1 && loanMonths <= 3)) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 1 : 1) / 100;
  } else if (loanMonths >= 4 && loanMonths <= 6) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 2 : 1) / 100;
  } else if (loanMonths >= 7 && loanMonths <= 12) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 4 : 2) / 100;
  } else if (loanMonths >= 13 && loanMonths <= 24) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 6 : 3) / 100;
  } else if (loanMonths >= 25 && loanMonths <= 36) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 6.70 : 4) / 100;
  } else if (loanMonths >= 37 && loanMonths <= 48) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 7.40 : 6) / 100;
  } else if (loanMonths >= 49 && loanMonths <= 60) {
    bloom = (goal < MINIMUM_AMOUNT_BLOOM ? 8 : 7) / 100;
  }

  return bloom;
}

function getFNG({ goal }) {
  const MINIMUM_AMOUNT_FNG = 200000000;
  return (goal < MINIMUM_AMOUNT_FNG ? 1 : 2) / 100;
}

// function getDeferredGracePeriod({
//   goal,
//   IEM,
//   monthsGracePeriod,
//   PERIOD,
// }) {
//   if (goal <= 0 || IEM <= 0 || monthsGracePeriod <= 0 || PERIOD <= 0) {
//     return 0;
//   }
//
//   let count = 1;
//   let interestsT = 0;
//   const interests = goal * IEM;
//
//   while (count <= monthsGracePeriod) {
//     if (count === 1) {
//       interestsT = interests;
//     } else {
//       interestsT = interests + interestsT;
//     }
//     count += 1;
//   }
//   return (interestsT / PERIOD);
// }

// function getMonthsPayment({ goal, FIXED_FEE_1, IEM }) {
//   if (goal <= 0 || IEM <= 0 || FIXED_FEE_1 <= 0) {
//     return 0;
//   }
//
//   let months = 0;
//   let finalBalance = goal;
//   let initialBalance = goal;
//   let interests = goal * IEM;
//   let capitalSubscription = interests;
//   while (finalBalance > 0) {
//     initialBalance = finalBalance;
//     interests = initialBalance * IEM;
//     capitalSubscription = FIXED_FEE_1 - interests;
//     finalBalance = initialBalance - capitalSubscription;
//     months += 1;
//   }
//   return months;
// }

export const CalculationSimulatorController = ({
  children,
  pctReturn = 10,
  goal = 1000000,
  loanMonths = 24,
  monthsGracePeriod = 6,
  paymentPeriod = 'BIMONTHLY',
  // isDeferredGracePeriod = true,
}) => {
  if (typeof pctReturn !== 'number'
  || typeof goal !== 'number'
  || typeof loanMonths !== 'number'
  || typeof monthsGracePeriod !== 'number') {
    throw new Error('Solo debes agregar valores numericos');
  }

  const IEA = pctReturn / 100;

  const { id, value: paymentDetails } = findPaymentPeriodWithKey(paymentPeriod);

  const PERIOD = loanMonths / id;

  const IEM = ((1 + IEA) ** ((30 * id) / 360)) - 1;

  const FIXED_FEE_1 = (IEA > 0 && PERIOD > 0) ? ((goal * IEM) / (1 - ((1 + IEM) ** (-PERIOD)))) : 0;

  const FIXED_FEE_2 = FIXED_FEE_1 * PERIOD;

  // const ADMIN = 1 / 100;

  const TOTAL_MONTHS_OF_CREDITS = loanMonths + monthsGracePeriod;

  const BLOOM = useMemo(() => getBloom({ goal, loanMonths }), [goal, loanMonths]);

  const FNG = useMemo(() => getFNG({ goal }), [goal]);

  // const monthsPayment = useMemo(() => getMonthsPayment({
  //   goal,
  //   FIXED_FEE_1,
  //   IEM,
  // }), [goal, FIXED_FEE_1, IEM]);

  // const deferredGracePeriod = useMemo(() => {
  //   let value = 0;
  //   if (isDeferredGracePeriod) {
  //     value = getDeferredGracePeriod({
  //       goal,
  //       IEM,
  //       monthsGracePeriod,
  //       PERIOD,
  //     }) * monthsPayment;
  //   }
  //   return value;
  // }, [isDeferredGracePeriod, goal, IEM, monthsGracePeriod, PERIOD, monthsPayment]);

  // const pagoAdmin = (FIXED_FEE_1 * ADMIN) * (monthsPayment);

  // const TOTAL_PAID_ENTREPRENEUR = (goal * BLOOM)
  // + (goal * FNG) + deferredGracePeriod + FIXED_FEE_2 + pagoAdmin;
  const TOTAL_PAID_ENTREPRENEUR = PERIOD * FIXED_FEE_1;

  return children({
    goal,
    totalPaid: TOTAL_PAID_ENTREPRENEUR,
    totalMonths: TOTAL_MONTHS_OF_CREDITS,
    FixedFee: [FIXED_FEE_1, FIXED_FEE_2],
    Bloom: BLOOM,
    period: PERIOD,
    paymentDetails,
    IEM,
    FNG,
  });
};
